import React, { useState, useEffect } from "react";
// import Modal from "react-modal";
import { capitalize, Modal, Box, Typography, TextField, Button, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import { SendPostRequest } from "../http";
import { setPatientLogin } from "../store/global/actions";
import HeaderWrapper from "./Header/HeaderWrapper";
import FooterWrapper from "./Footer/FooterWrapper";
import TextMainBannerWrapper from "./TextMainBanners/TextMainBannerWrapper";

function Login() {
  const sitedata = useSelector((store) => store.global.loginData);
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const profileCheck = useSelector((store) => store.global.profileCheck);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [sendMailLoading, setSendMailLoading] = useState(false);
  const [patientisLoading, setPatientisLoading] = useState(false);
  const [hospitalisLoading, setHospitalisLoading] = useState(false);

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setHospitalisLoading(true);

    if (username.length === 0) {
      toast.error("Enter Email");
      setHospitalisLoading(false);
      return;
    } else if (!username.includes("@")) {
      toast.error("Invalid Email");
      setHospitalisLoading(false);
      return;
    }
    try {
      const response = await SendPostRequest("auth/login", {
        login_email: username,
        login_password: password,
        // login_type: sitedata?.site_type,
      });
      setUsername([]);
      setPassword([]);

      if (response.data) {
        if (response.status === "success") {
          const redirectUrl = response?.data.url;
          if (redirectUrl) {
            window.open(redirectUrl, "_blank");
          }

          toast.success("You are logged in");
        } else {
          setHospitalisLoading(false);
          toast.error("User Not Found");
        }
      } else {
        if (response.errorCode === "INVALID_CREDENTIALS") {
          toast.error("Incorrect username or password");
          setHospitalisLoading(false);
        } else {
          toast.error("Login failed. Please check your credentials.");
          setHospitalisLoading(false);
        }
      }
    } catch (error) {
      toast.error("Login failed. Please check your credentials.");
      console.error("Login failed:", error);
      setHospitalisLoading(false);
    } finally {
      setHospitalisLoading(false);
    }
  };

  const [contactNum, setContactNum] = useState("");
  const [patientPassword, setpatientPassword] = useState("");
  const handleUserContactChange = (e) => {
    setContactNum(e.target.value);
  };

  const handlePatientPasswordChange = (e) => {
    setpatientPassword(e.target.value);
  };

  const handlePatientLogin = async (e) => {
    e.preventDefault();
    setPatientisLoading(true);

    if (contactNum.length === 0) {
      toast.error("Enter Email / Phone Number");
      setPatientisLoading(false);
      return;
    } else if (patientPassword.length === 0) {
      toast.error("Enter your Password");
      setPatientisLoading(false);
      return;
    }

    try {
      const response = await SendPostRequest("auth/patient_login", {
        contactnumber: contactNum,
        password: patientPassword,
        // login_type: sitedata?.site_type,
      });
      setContactNum([]);
      setpatientPassword([]);

      if (response.data) {
        if (response.status === "success") {
          dispatch(setPatientLogin(response?.data));
          toast.success("Patient logged in");
          navigate("/patient");
        } else {
          toast.error("User not found");
          setPatientisLoading(false);
        }
      } else {
        if (response.errorCode === "INVALID_CREDENTIALS") {
          toast.error("Incorrect username or password");
          setPatientisLoading(false);
        } else {
          toast.error("Login failed. Please check your credentials.");
          setPatientisLoading(false);
        }
      }
    } catch (error) {
      toast.error("Login failed. Please check your credentials.");
      console.error("Login failed:", error);
      setPatientisLoading(false);
    }
  };

  const [forgotEmail, setForgotEmail] = useState("");

  const handleChangeForgotEmail = (e) => {
    setForgotEmail(e.target.value);
  };

  const handleClickForgotEmail = async (e) => {
    if (forgotEmail === "") {
      toast.error("Enter Email");
      setSendMailLoading(false);
      return;
    } else if (!forgotEmail.includes("@")) {
      toast.error("Enter Valid Email");
      setSendMailLoading(false);
      return;
    }
    setSendMailLoading(true);

    try {
      const response = await SendPostRequest("auth/forget_password", {
        action: "send_email",
        email: forgotEmail,
      });
      if (response?.status === "success") {
        toast.success(response?.message);
        setForgotEmail("");
        setModalIsOpen(false);
      } else {
        toast.error(response?.message);
        setSendMailLoading(false);
      }
    } catch (error) {
      toast.error("Login failed. Please check your credentials.");
      setSendMailLoading(false);
      console.error("Login failed:", error);
    }
  };

  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  function openModal() {
    setModalIsOpen(true);
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  const handlePatientKeyDown = (e) => {
    if (e.key === "Enter") {
      handlePatientLogin(e);
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="page-wrapper-inner">
      <div class="page-wrapper-inner">
        <ToastContainer />
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Login" Image="theme-2-banner-login.webp" />
        {/* <div className="page-title-wrap typo-white">
          <div
            className="page-title-wrap-inner section-bg-img"
            data-bg="/assets/images/bg/page-title-bg.jpg"
            style={{
              backgroundImage: "url(/assets/images/bg/page-title-bg.jpg)",
            }}
          >
            <span className="black-overlay"></span>
            <div className="container">
              <div className="row text-center">
                <div className="col-md-12">
                  <div className="page-title-inner">
                    <h1 className="page-title mb-0">Login</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="content-wrapper pad-none">
          <div className="content-inner">
            {sitedata?.theme_login_form === "colored" ? (
              <section id="section-contact" className="py-5" style={{ background: "#000" }}>
                <div className="container">
                  <div
                    // className={`row ${sitedata?.patient_portal !== 1 ? "" : "justify-content-center"}`}
                    className={`row ${sitedata?.patient_portal !== 1 ? "justify-content-center" : ""}`}
                  >
                    <div className="col-md-12">
                      <div className="title-wrap text-center">
                        <div className="section-title">
                          <h2 className="title mb-0 text-uppercase text-white">
                            Login Your Account
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12 mb-5">
                      <form
                        id="contact-form"
                        className="login-colored-bd pad-40"
                        method="post"
                      >
                        {sitedata.site_type == "hospitals" ? (
                          <h3 className="title mb-4 text-white">Hospital Login</h3>
                        ) : (
                          <h3 className="title mb-4 text-white">Doctor Login</h3>
                        )}
                        <div id="success"></div>
                        <input
                          className="form-control mb-3"
                          type="email"
                          name="name"
                          placeholder="Type Your Email"
                          value={username}
                          onChange={handleUsernameChange}
                          required
                        />
                        <input
                          className="form-control"
                           style={{
                                marginBottom: isMobile ? "10px" : "10px",
                              }}
                          type="password"
                          placeholder="Enter Your Password"
                          value={password}
                          onChange={handlePasswordChange}
                          required
                        />
                        <div className="clearfix"></div>
                        <button
                          type="submit"
                          onClick={handleLogin}
                          disabled={hospitalisLoading}
                          className="btn login-colored-btn mt-2"
                        >
                          {hospitalisLoading ? "Please Wait" : "Login"}
                        </button>
                      </form>
                    </div>
                    {sitedata?.patient_portal == 1 && (
                      <div className="col-lg-6 col-md-12 col-12 mb-5">
                        <form
                          id="contact-form"
                          className="login-colored-bd pad-40"
                          onKeyDown={handlePatientKeyDown}
                        >
                          <h3 className="title mb-4 text-white">Patient Login</h3>
                          <div id="success"></div>
                          <input
                            className="form-control mb-3"
                            type="text"
                            placeholder="Enter Your Email/Phone Number"
                            value={contactNum}
                            onChange={handleUserContactChange}
                          />
                          <input
                            className="form-control"
                             style={{
                                marginBottom: isMobile ? "0px" : "10px",
                              }}
                            type="password"
                            placeholder="Enter Your Password"
                            value={patientPassword}
                            onChange={handlePatientPasswordChange}
                          />
                         <div>
                            {isMobile ? (
                            <span className="pull-right w-100 d-flex justify-content-end mb-2">
                              <Link className="text-white" onClick={openModal}>Forgt Password?</Link>
                            </span>
                          ) : null}
                         </div>
                          
                          <div className="clearfix"></div>
                          <button
                            type="button "
                            onClick={handlePatientLogin}
                            disabled={patientisLoading}
                            className="btn login-colored-btn mt-2"
                          >
                            {patientisLoading ? "Please Wait" : "Login "}
                          </button>
                          <Link to={"/signup"}>
                            <button type="button" className="btn login-colored-btn mt-2 ml-3">
                              Sign Up
                            </button>
                          </Link>
                          {!isMobile ? (
                            <span className="pull-right">
                              <Link className="text-white" onClick={openModal}>Forgot Password?</Link>
                            </span>
                          ) : null}
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </section>
            ) : (
              <>
                <section id="section-contact" className="pad-top-5 pt-5 pb-2">
                  <div className="container">
                    <div
                      className={`row ${sitedata?.patient_portal !== 1 ? "justify-content-center" : ""
                        }`}
                      //  className={`row ${sitedata?.patient_portal !== 1 ? "" : "justify-content-center"}`}

                    >
                      <div className="col-md-12">
                        <div className="title-wrap text-center">
                          <div className="section-title">
                            <h2 className="title mb-0 text-uppercase">
                              Login Your Account
                            </h2>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12 col-12 mb-5">
                        <form
                          id="contact-form"
                          className=" bg-grey pad-40"
                          method="post"
                        >
                          {sitedata.site_type == "hospitals" ? (
                            <h3 className="title mb-3">Hospital Login</h3>
                          ) : (
                            <h3 className="title mb-3">Doctor Login</h3>
                          )}
                          <div id="success"></div>
                          <input
                            className="form-control mb-3"
                            type="email"
                            name="name"
                            placeholder="Type Your Email"
                            value={username}
                            onChange={handleUsernameChange}
                            required
                          />
                          <input
                            className="form-control"
                             style={{
                                marginBottom: isMobile ? "10px" : "10px",
                              }}
                            type="password"
                            placeholder="Enter Your Password"
                            value={password}
                            onChange={handlePasswordChange}
                            required
                          />
                          <div className="clearfix"></div>
                          <button
                            type="submit"
                            onClick={handleLogin}
                            disabled={hospitalisLoading}
                            className="btn btn-default"
                          >
                            {hospitalisLoading ? "Please Wait" : "Login"}
                          </button>
                        </form>
                      </div>
                      {sitedata?.patient_portal == 1 && (
                        <div className="col-lg-6 col-md-12 col-12 mb-5">
                          <form
                            id="contact-form"
                            className=" bg-grey pad-40"
                            onKeyDown={handlePatientKeyDown}
                          >
                            <h3 className="title mb-3">Patient Login</h3>
                            <div id="success"></div>
                            <input
                              className="form-control mb-3"
                              type="text"
                              placeholder="Enter Your Email/Phone Number"
                              value={contactNum}
                              onChange={handleUserContactChange}
                            />
                            <input
                              className="form-control"
                              style={{
                                marginBottom: isMobile ? "0px" : "10px",
                              }}
                              type="password"
                              placeholder="Enter Your Password"
                              value={patientPassword}
                              onChange={handlePatientPasswordChange}
                            />
                            {isMobile ? (
                               <span className="pull-right w-100 d-flex justify-content-end mb-2">
                                <Link onClick={openModal}>Forgot Password?</Link>
                              </span>
                            ) : null}
                            <div className="clearfix"></div>
                            <button
                              type="button"
                              onClick={handlePatientLogin}
                              disabled={patientisLoading}
                              className="btn btn-default"
                            >
                              {patientisLoading ? "Please Wait" : "Login "}
                            </button>
                            <Link to={"/signup"}>
                              <button type="button" className="btn btn-default ml-3">
                                Sign Up
                              </button>
                            </Link>
                            {!isMobile ? (
                              <span className="pull-right">
                                <Link onClick={openModal}>Forgot Password?</Link>
                              </span>
                            ) : null}
                            {/* <span className="pull-right">
                              <Link onClick={openModal}>Forget Password?</Link>
                            </span> */}
                          </form>
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              </>)}

          </div>
        </div>
        <FooterWrapper />
      </div>

      {/* Material UI Dialog for Password Recovery */}
      <Modal
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: isMobile ? "40%" : "30%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? 375 : 520,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: isMobile ? 2 : 3,
            minHeight: "220px",
          }}
        >
          {/* Title + Close button */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2,  }}>
            <Typography id="modal-title" variant="h6" component="h2">
              Password Recovery
            </Typography>
            <IconButton className="btn btn-default" onClick={closeModal}>
              <Close />
            </IconButton>
          </Box>

          {/* Input */}
          <TextField
            fullWidth
            id="email"
            label="Email Address"
            type="email"
            variant="outlined"
            value={forgotEmail}
            onChange={handleChangeForgotEmail}
            placeholder="Enter your email address"
            sx={{ mb: 3, mt: 2 }}
          />

          {/* Actions */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, textTransform:"capitalize" }}>
            <Button className="btn btn-default" sx={{textTransform:"capitalize"}}  onClick={closeModal} variant="outlined">Cancel</Button>
            <Button className="btn btn-default"
            sx={{textTransform:"capitalize"}}
              onClick={handleClickForgotEmail}
              disabled={sendMailLoading}
              variant="contained"
            >
              {sendMailLoading ? "Sending..." : "Send Email"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default Login;